import ContactUsService from '@/api/ContactUsService';
import cloneDeep from 'lodash/cloneDeep';

const state = {
  officesInformation: {
    email: '',
    webSite: '',
    facebook: '',
    offices: [],
  },
  externalDirectory: [],
  officeDirectory: [],
  officeRepresentatives: [],
  // liveChatInitialized: false
};

const getters = {
  getPhoneOnly: () => (phones) => {
    let filteredPhones = [];
    if (phones) {
      filteredPhones = phones.filter(
        p => p.type && (p.type.toUpperCase() !== 'PHONE_NUMBER_TYPE.FAX'),
      );
    }
    return filteredPhones;
  },
  getFaxOnly: () => (phones) => {
    let faxNumber = '';
    if (phones) {
      const filteredPhones = phones.filter(
        p => p.type && (p.type.toUpperCase() === 'PHONE_NUMBER_TYPE.FAX'),
      );
      if (filteredPhones.length > 0) {
        faxNumber = filteredPhones[0].number;
      }
    }
    return faxNumber;
  },
  getOffices: () => (directory) => {
    let offices = [];
    if (directory && directory.offices && Array.isArray(directory.offices)) {
      ({ offices } = directory);
    } else if (directory && Array.isArray(directory)) {
      offices = directory;
    }
    offices = cloneDeep(offices);
    return offices.sort(
      (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
    );
  },
  getOfficeInformation: (state, getters) => (officeId) => {
    let officeFound = {};
    getters.getOffices(state.officeDirectory).forEach((office) => {
      if (office.id === officeId) {
        officeFound = cloneDeep(office);
      }
    });
    return officeFound;
  },
};

const actions = {
  init({ commit }) {
    commit('officesInformation', {
      email: '',
      webSite: '',
      facebook: '',
      offices: [],
    });
    commit('externalDirectory', []);
    commit('officeDirectory', []);
    commit('officeRepresentatives', []);
  },
  getOfficesInformation({ commit, dispatch }) {
    dispatch('init');
    return ContactUsService.getOfficesInformation().then((response) => {
      commit('officesInformation', response.data);
    });
  },
  getExternalDirectory({ commit, dispatch }) {
    dispatch('init');
    return ContactUsService.getExternalDirectory().then((response) => {
      commit('externalDirectory', response.data);
    });
  },
  getOfficeDirectory({ commit, dispatch }) {
    dispatch('init');
    return ContactUsService.getOfficeDirectory().then((response) => {
      commit('officeDirectory', response.data);
    });
  },
  getOfficeRepresentatives({ commit }, officeId) {
    commit('officeRepresentatives', []);
    return ContactUsService.getOfficeRepresentatives(officeId).then((response) => {
      commit('officeRepresentatives', response.data);
    });
  },
};

const mutations = {
  officesInformation(state, payload) {
    state.officesInformation = payload;
  },
  externalDirectory(state, payload) {
    state.externalDirectory = payload;
  },
  officeDirectory(state, payload) {
    state.officeDirectory = payload;
  },
  officeRepresentatives(state, payload) {
    state.officeRepresentatives = payload;
  },
  // liveChatInitialized(state, payload) {
  //   state.liveChatInitialized = payload;
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
